<template>
  <div class="login">
    <div class="container">
      <div class="login--wrapper d-flex align-items-center justify-content-center flex-column">
        <div class="login--icon">
          <b-img
            :src="company ? rootDomain + company + '_logo.png' : rootDomain + 'logo_unidade.png'"
            fluid
            alt="Thumbnail" />
        </div>

        <fieldset
          v-if="course"
          class="form--container">
          <div class="form--title">
            <span>{{ course.nome_curso }}</span>
          </div>

          <div class="text-center font-weight-bold">
            <p>Matricule-se agora mesmo no curso {{ course.nome_curso }}</p>
          </div>

          <table class="table bg-white">
            <thead>
              <tr>
                <td>Item</td>
                <td>Valor</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Curso</td>
                <td>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorCurso) }}</td>
              </tr>
              <tr>
                <td>Taxa de matrícula</td>
                <td>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(course.valor_matricula) }}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center font-weight-bold py-4">
            <p v-if="canShowBoletoPercelado">Parcelado em até {{ course.quantidade_parcelas }}x no boleto</p>
            <p v-if="canShowGetwayCartao">Parcelado em até {{ course.quantidade_parcelas > 12 ? 12 : course.quantidade_parcelas }}x no cartão de crédito.</p>
          </div>

          <div
            v-if="$route.name === 'matricular-courseId-unitId'"
            class="text-center pb-4">
            <b-button
              variant="secondary"
              @click="generateEnrollment()">
              Prosseguir com a matrícula
            </b-button>
          </div>

          <nuxt-child/>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { Enroll } from '@/services/enroll'
import {mapGetters} from "vuex";

export default {
  layout: 'auth',
  data: function () {
    return {
      enrollmentId: null
    }
  },
  computed: {
    course() {
      return this.$store.getters['enroll/course']
    },
    company () {
      return process.env.company
    },
    rootDomain () {
      return process.env.rootDomain
    },
    valorCurso () {
      return this.course.valor_juros || this.course.valor_juros == 0 ? this.course.valor_a_vista : this.course.valor_total
    },
    ...mapGetters({
      getAllDefaultOptions: 'config/getAllDefaultOptions'
    }),
    canShowBoletoPercelado() {
      return this.getAllDefaultOptions.boleto_configurado.boleto &&
        this.course.boleto_parcelado
    },
    canShowGetwayCartao() {
      return this.getAllDefaultOptions.boleto_configurado.getway
    },
  },
  mounted () {
    Enroll.enrollCourseUnit(this.$route.params.courseId, this.$route.params.unitId)
      .then(response => {
        this.$store.commit('enroll/setCourse', response.data);
      }).catch(error => {
        this.$toast.error(error.error)
      });
  },
  methods: {
    generateEnrollment() {
      if(this.$store.state.app.auth.check) {
        this.$router.replace({ name: 'matricular-courseId-unitId-pagamento',
          params: {
            courseId: this.$route.params.courseId,
            unitId: this.$route.params.unitId
          }
        });
      } else {
        this.$router.replace({ name: 'matricular-courseId-unitId-identificacao',
          params: {
            courseId: this.$route.params.courseId,
            unitId: this.$route.params.unitId
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login--wrapper {
  width: 100%;
  padding: 25px 35px;
}

form legend {
  font-size: 1rem;
  font-weight: bold;
}
</style>
